import { jsxs as h, jsx as l, Fragment as x } from "react/jsx-runtime";
import { forwardRef as v, useState as N, useMemo as w, cloneElement as g, useCallback as P, Children as y } from "react";
import { c as b } from "./tw-cn-mXgPecoF.mjs";
const r = {
  unselected: "size-22",
  touchdown: "size-18",
  // 18x18
  touchup: "size-26"
  // 26x26
}, z = v((d, m) => {
  const { icon: n, activeIcon: o, title: c = "", link: u = "", isActive: i = !1, badge: p, ...e } = d, [t, a] = N(r.unselected), f = w(() => {
    const s = i && o || n;
    return s ? g(s, {
      ...s.props,
      className: b(`${s.props.className} transition-all duration-100 ${t} `, n == null ? void 0 : n.props.className)
    }) : null;
  }, [n, o, t, i]);
  return /* @__PURE__ */ h(
    "a",
    {
      className: "relative flex h-56 items-center justify-center pb-4",
      href: u || void 0,
      onPointerCancel: () => {
        a(r.unselected);
      },
      onPointerDown: () => {
        a(r.touchdown);
      },
      onPointerLeave: () => {
        a((s) => s === r.touchdown ? r.unselected : s);
      },
      onPointerUp: () => {
        a(r.touchup), setTimeout(() => {
          a(r.unselected);
        }, 100);
      },
      ref: m,
      role: "button",
      title: c,
      ...e,
      children: [
        /* @__PURE__ */ h("div", { className: "flex size-40 flex-col items-center overflow-hidden rounded-12 active:bg-opacity-black-5", children: [
          /* @__PURE__ */ l("div", { className: "m-auto flex size-26 max-h-26 min-h-26 items-center justify-center pb-2", children: f }),
          /* @__PURE__ */ l(
            "span",
            {
              className: b(
                `text-nowrap typography-label-10-regular-fixed ${o && i ? "!font-bold" : "font-normal"}`
              ),
              children: c
            }
          )
        ] }),
        p
      ]
    }
  );
});
z.displayName = "NDS.TabButton";
const S = v((d, m) => {
  const { children: n, onChange: o } = d, [c, u] = N(-1), i = P(() => {
    navigator.vibrate && navigator.vibrate(200);
  }, []), p = (e, t) => (a) => {
    i(), t == null || t(a), o == null || o(a, e), setTimeout(() => {
      u((f) => f === e ? -1 : e);
    }, 100);
  };
  return /* @__PURE__ */ h(x, { children: [
    /* @__PURE__ */ l("div", { className: "flex h-1 border-t border-t-opacity-black-10" }),
    /* @__PURE__ */ l(
      "nav",
      {
        className: "mx-auto grid w-full max-w-legacy-pc-size grid-cols-[repeat(auto-fit,minmax(0,1fr))] justify-center gap-0 bg-static-white px-8 pb-[env(safe-area-inset-bottom)]",
        ref: m,
        children: y.map(
          n,
          (e, t) => e ? g(e, {
            ...e.props,
            onClick: p(t, e.props.onClick),
            isActive: e.props.isActive ? !0 : c === t
          }) : null
        )
      }
    )
  ] });
});
S.displayName = "NDS.BottomNavigation";
export {
  S as B,
  z as T
};
